import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-svm-crudui',
  template: `
    <p>
      svm-crudui works!
    </p>
  `,
  styles: [
  ]
})
export class SvmCruduiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
